import React from "react";
import "./Home.css";
import "../PageContent.css";
import Header from "../../../components/Header";
import {FormattedMessage, useIntl} from "react-intl";
import {LoadingSkeleton} from "@spg/component_library";
import {CoreAppResponse, MyGroupApps} from "../../../logic/APITypes";
import {MyGroupApp} from "../../../components/MyGroupApp";
import {HomeApp} from "../../../components/HomeApp";

type HomeProps = {
  /** The tiles to be shown in the my app section */
  myGroupApps: MyGroupApps[];
  /** The tiles to be shown in the core app section */
  coreApps: CoreAppResponse[];
  /** Whether the installed app tiles are currently loading */
  myGroupAppsLoading?: boolean;
  /** Whether the core app tiles are currently loading */
  coreAppTilesLoading?: boolean;
};

/** The landing page when opening the hosting platform. Provides links to important functionalities */
function Home({
  myGroupApps,
  coreApps,
  myGroupAppsLoading,
  coreAppTilesLoading,
}: HomeProps) {
  const {formatMessage} = useIntl();

  return (
    <>
      <Header title={formatMessage({id: "home.header.page"})} />
      <div className="content">
        {(myGroupAppsLoading || myGroupApps.length > 0) && (
          <>
            <h2 className="content__header">
              <FormattedMessage id="home.header.apps" />
            </h2>
            <div className="content__column">
              {myGroupAppsLoading ? (
                <div className="home__skeleton">
                  <LoadingSkeleton />
                </div>
              ) : (
                myGroupApps.map((app) => <MyGroupApp key={app.id} {...app} />)
              )}
            </div>
          </>
        )}
        {(coreAppTilesLoading || coreApps.length > 0) && (
          <>
            <h2 className="content__header">
              <FormattedMessage id="home.header.coreApps" />
            </h2>
            <div className="content__row content__row--last">
              {coreAppTilesLoading ? (
                <div className="home__skeleton">
                  <LoadingSkeleton />
                </div>
              ) : (
                coreApps.map((app) => (
                  <HomeApp
                    key={app.name}
                    {...app}
                    detailsLink={"/apps/core/" + app.id}
                    isCoreApp
                  />
                ))
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Home;
